import React from "react";
import TitleHeader from "../../global/TitleHeader";
import NewsLetter from "../home/NewsLetter";
import Services from "../home/Services";
import Offer from "../home/Offer";

const ServiceIndex = () => {
  return (
    <div className="flax-col gap-14">
      <TitleHeader
        title="Services"
        description="Comprehensive thermocol packaging services tailored to meet your product protection and shipping needs."
      />
      <Services/>
      <Offer/>
      <NewsLetter />
    </div>
  );
};

export default ServiceIndex;
